<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId">
    @if (isLoading) {
      <div class="loader-container">
        <app-spinner></app-spinner>
      </div>
    }
    @if (!isLoading) {
      <div>
        @if (!waitingResponse && !successfulResponse) {
          @if (checkModalType('ACCEPT')) {
            <app-offer-modals-header [heading]="CONSTANTS.labelAccept"
              [tenantName]="tenantName">
            </app-offer-modals-header>
          }
          @if (checkModalType('COUNTER')) {
            <app-offer-modals-header [heading]="CONSTANTS.labelCounter"
              [tenantName]="tenantName">
            </app-offer-modals-header>
          }
          @if (checkModalType('DECLINE')) {
            <app-offer-modals-header [heading]="CONSTANTS.labelDecline"
              [tenantName]="tenantName">
            </app-offer-modals-header>
          }
          @if (checkModalType('WITHDRAW')) {
            <app-offer-modals-header [heading]="CONSTANTS.labelWithdraw"
              [tenantName]="tenantName">
            </app-offer-modals-header>
          }
          @if (checkModalType('REVIVE')) {
            <app-offer-modals-header [heading]="CONSTANTS.labelRevive"
              [tenantName]="tenantName">
            </app-offer-modals-header>
          }
          <div class="modal__content">
            @if (isMultiActionBuyerModal) {
              @if (checkModalType('ACCEPT')) {
                <p [innerHTML]=CONSTANTS.textAcceptOffers></p>
              }
              @if (checkModalType('DECLINE')) {
                <p [innerHTML]=CONSTANTS.textDeclineOffers></p>
              }
            }
            <app-multi-offer-history [items]="items" [userType]="userType"
              [showSpareKey]="showSpareKey"
              [platformSpareKeyFee]="platformSpareKeyFee()"
              [spareKeySelections]="spareKeySelections()"
              (spareKeyChange)="onSpareKeyChange($event)">
            </app-multi-offer-history>
          </div>
          <form name="makeComments" [formGroup]="form" novalidate>
            <div class="form-group">
              <label class="d-block text-start" for="counter-offer-comment">{{CONSTANTS.labelComments}}</label>
              <textarea id="offerListActionModal_counter_offer_comment" class="form-control" rows="3" maxlength="150"
                formControlName="offerComment" (keyup)="replaceInvalidCharacters($event)" appCharacterCount
                #comment="appCharacterCount">
              </textarea>
              <app-character-count [count]="comment.count$ | async" [maxLength]="150"
                [characterCountTranslate]="characterCountData">
              </app-character-count>
              <div class="form-group service-fee-details">
                <app-datalist-item identifier="auction_info_service_fee_text"
                  [label]="CONSTANTS.labelTotalOfOffers"
                  value="{{ formatCurrency(totalOfferAmount, false) }}">
                </app-datalist-item>
                <app-datalist-item identifier="auction_info_service_fee_text"
                  [label]="CONSTANTS.labelTotalFees"
                  value="{{ formatCurrency(totalFees, true) }}">
                  <span>
                    @switch (isMobile) {
                      @case (true) {
                        <span>
                          <app-tooltip [tooltip]="getFeeDetailsTooltip()" [showToolTipAsHtml]="true"
                            triggers="click :keydown.escape :keydown.tab"
                            allytmln="Service Fee Details">
                            <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                          </app-tooltip>
                        </span>
                      }
                      @case (false) {
                        <span>
                          <app-tooltip [tooltip]="getFeeDetailsTooltip()" [showToolTipAsHtml]="true"
                            triggers="hover :keydown.escape :keydown.tab"
                            allytmln="Service Fee Details">
                            <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                          </app-tooltip>
                        </span>
                      }
                      @default {
                        <span>
                          <app-tooltip [tooltip]="getFeeDetailsTooltip()" [showToolTipAsHtml]="true"
                            triggers="hover click :keydown.escape :keydown.tab"
                            allytmln="Service Fee Details">
                            <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                          </app-tooltip>
                        </span>
                      }
                    }
                  </span>
                </app-datalist-item>
                @if (showSpareKey) {
                  <app-datalist-item identifier="multi_action_spare_key_total_text"
                    data-testid="shared-list-multi-action-modal-spare-key-total"
                    [label]="CONSTANTS.labelSpareKeyTotal"
                    value="{{ formatCurrency(spareKeyTotal, false) }}">
                  </app-datalist-item>
                }
                <hr>
                  <app-datalist-item identifier="auction_info_service_fee_text"
                    [label]="CONSTANTS.labelTotalPurchasePrice"
                    value="{{ formatCurrency(totalPurchasePrice, true) }}">
                  </app-datalist-item>
                  <ng-container *ngTemplateOutlet="financeSourceFeeMessages"></ng-container>
                </div>
              </div>
              @if (checkModalType('COUNTER')) {
                <div>
                  <div class="d-lg-flex mb-0">
                    <div class="form-group modal__input-container">
                      <label class="d-block text-start"
                      for="counter-offer-amount">{{convert('sellModule.offers.counter.textCounterOfferUpper')}}</label>
                      <app-currency-input
                        [inputConfig]="counterInputConfig"
                        [inputForm]="form"
                        [inputId]="'counter-offer-amount'"
                        (inputKeyUp)="validateAmount()"
                      ></app-currency-input>
                    </div>
                  </div>
                </div>
              }
              @if (checkModalType('REVIVE')) {
                <div>
                  <div class="d-lg-flex mb-0">
                    <div class="form-group modal__input-container">
                      <label class="d-block text-start"
                      for="revive-offer-amount">{{convert('sellModule.offers.revive.labelReviveOffer')}}</label>
                      <app-currency-input
                        [inputConfig]="reviveInputConfig"
                        [inputForm]="form"
                        [inputId]="'revive-offer-amount'"
                      ></app-currency-input>
                    </div>
                  </div>
                </div>
              }
            </form>
            <div class="error-message" aria-live="polite" tabindex="-1">
              @if (incorrectAmount) {
                <strong>{{CONSTANTS.counterOfferAmountError}}<br /></strong>
              }
              @if (isAmountEmpty) {
                <strong>{{CONSTANTS.emptyOfferAmountError}}<br /></strong>
              }
            </div>
            <div class="modal__content">
              @switch (isCurrentUserBuyer()) {
                @case (true) {
                  @if (checkModalType('ACCEPT')) {
                    <p [innerHTML]="CONSTANTS.textSellingDisclosure"></p>
                  }
                  @if (checkModalType('DECLINE')) {
                    <p [innerHTML]="CONSTANTS.textPermanentAction"></p>
                  }
                }
                @case (false) {
                  @if (checkModalType('ACCEPT')) {
                    <p [innerHTML]="CONSTANTS.textAcceptOffers"></p>
                  }
                  @if (checkModalType('DECLINE')) {
                    <p [innerHTML]="CONSTANTS.textDeclineOffers"></p>
                  }
                  @if (checkModalType('WITHDRAW')) {
                    <p [innerHTML]="CONSTANTS.textWithdrawOffers"></p>
                  }
                  @if (checkModalType('COUNTER')) {
                    <p [innerHTML]="CONSTANTS.textCounterBuyerOffer"></p>
                  }
                  @if (checkModalType('REVIVE')) {
                    <p [innerHTML]="CONSTANTS.textReviveOffer"></p>
                  }
                }
              }
            </div>
            <div class="errorBox" aria-atomic="true" aria-live="polite">
              @if (errorMessage) {
                <p class="text-danger fw-bold" id="offer-error" role="alert">{{ errorMessage }}</p>
              }
            </div>
            <div class="d-flex flex-column flex-lg-row lg-justify-content-start action-buttons">
              @if (checkModalType('ACCEPT')) {
                <button class="btn btn-primary" (click)="submitAction()" type="button"
                  data-track-elem="button" allytmln="acceptBuyAction" id="offerListActionModal_accept_offer_button">
                  {{ CONSTANTS.btnAccept }}
                </button>
              }
              @if (checkModalType('DECLINE')) {
                <button [class]="declineButtonClass" (click)="submitAction()" type="button"
                  data-track-elem="button" allytmln="declineBuyAction" id="offerListActionModal_decline_offer_button">
                  {{ CONSTANTS.btnDecline }}
                </button>
              }
              @if (checkModalType('WITHDRAW')) {
                <button class="btn btn-primary" (click)="submitAction()" type="button"
                  data-track-elem="button" allytmln="withdrawBuyAction" id="offerListActionModal_withdraw_offer_button">
                  {{ CONSTANTS.btnWithdraw }}
                </button>
              }
              @if (checkModalType('COUNTER')) {
                <button class="btn btn-primary" (click)="counter()" type="button"
                  data-track-elem="button" allytmln="counterBuyAction" id="offerListActionModal_counter_offer_button">
                  {{ CONSTANTS.btnCounter }}
                </button>
              }
              @if (checkModalType('REVIVE')) {
                <button class="btn btn-primary" (click)="revive()" type="button"
                  data-track-elem="button" allytmln="reviveBuyAction" id="offerListActionModal_revive_offer_button">
                  {{ CONSTANTS.btnRevive }}
                </button>
              }
              <button id="offerListActionModal_cancel_button" class="ms-lg-2 mt-3 mt-lg-0 btn btn-link" type="button"
                (click)="close()" data-track-elem="button" allytmln="cancelOfferModal" data-track-trigger="close">
                <span>{{ CONSTANTS.btnCancel }}</span>
              </button>
            </div>
            <div class="modal-close-container">
              <button class="modal__close" [attr.aria-label]="convert('common.modalClose')" (click)="close()"
                data-track-elem="icon" data-track-name="Close" data-track-trigger="close" id="do_close_x_button"
                #closeButton>
                <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
              </button>
            </div>
          }
          @if (isSubmitting()) {
            <app-action-submitting [actionText]="CONSTANTS.textActionWaitingOffers">
            </app-action-submitting>
          }
        </div>
      }
    </app-modal>

    <ng-template #financeSourceFeeMessages>
      @if (isCurrentUserBuyer() && (checkModalType('ACCEPT') || checkModalType('COUNTER'))) {
        @for (financeSource of selectedFinanceSources; track financeSource) {
          <p aria-labelledby="bid-modal-finance-source-fee-text"
            [innerHTML]="convert('vehicles.bidModal.textFinanceSourceFee',{name: financeSource.financeSourceName, amount: financeSource.feeAmount})">
          </p>
        }
      }
    </ng-template>
  </ng-container>
